import { createContext, useContext } from "react";
import Slider from "react-slick";

type SliderContextType = {
  sliderRef: React.RefObject<Slider> | null;
};

export const SliderContext = createContext<SliderContextType>({ sliderRef: null });
export const useSlider = () => useContext(SliderContext);
